import type { RootState } from '..';

export const selectCurrentFlagList = (state: RootState) =>
  state.currentFlag.currentFlagList;
